import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';
import spacing from 'styles/spacing';

const useStyles = makeStyles({
  noDataComponent: {
    padding: '48px 0',
    maxHeight: '64px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderTop: `1px solid ${colors.lightGray}`,
    borderBottom: `1px solid ${colors.lightGray}`,

    '& > span': {
      fontSize: fonts.sizes.small,
      color: colors.black,
      fontWeight: fonts.weights.normal,
      letterSpacing: '0.01px',
      lineHeight: '20px',
    },
  },
  loadingDataComponent: {
    padding: '24px 0',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rightComponentsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    '& > * + *': {
      marginLeft: `${spacing.xsmall}`,
    },
  },
  totalInfoContainer: {
    color: colors.black,
    fontWeight: fonts.weights.bold,
  },
  tableContainer: {
    '& > table': {
      borderCollapse: 'collapse',
      width: '97%',
    },
    '& > table > thead, th': {
      position: 'sticky',
      top: 0,
      zIndex: 999,
      backgroundColor: colors.white,
    },
    '& > table > tbody': {
      borderTop: `1px solid ${colors.lightGray}`,
      borderBottom: `1px solid ${colors.lightGray}`,
    },
    '& > tr, th': {
      margin: 0,
      padding: 0,
      color: colors.black,
      fontSize: fonts.sizes.small,
      letterSpacing: '0.1',
      lineHeight: '24px',
      fontWeight: fonts.weights.medium,
    },
    '& > tr, td': {
      margin: 0,
      padding: '0px 1px !important',
      wordBreak: 'break-all',
      color: colors.black,
      fontSize: '12px',
      letterSpacing: '0.25px',
      lineHeight: '15px',
      fontWeight: fonts.weights.normal,
    },
    '& MuiButtonBase-root MuiIconButton-root ': {
      padding: '0px 1px !important',
    },
  },
});

export default useStyles;
